import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Synopsis`}</h3>
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/ls.js */
    }
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm ls <package-spec>

alias: list
`}</code></pre>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/ls.js */
    }
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS END */
    }
    <h3>{`Description`}</h3>
    <p>{`This command will print to stdout all the versions of packages that are
installed, as well as their dependencies when `}<inlineCode parentName="p">{`--all`}</inlineCode>{` is specified, in a
tree structure.`}</p>
    <p>{`Note: to get a "bottoms up" view of why a given package is included in the
tree at all, use `}<a parentName="p" {...{
        "href": "/cli/v8/commands/npm-explain"
      }}><inlineCode parentName="a">{`npm explain`}</inlineCode></a>{`.`}</p>
    <p>{`Positional arguments are `}<inlineCode parentName="p">{`name@version-range`}</inlineCode>{` identifiers, which will limit
the results to only the paths to the packages named.  Note that nested
packages will `}<em parentName="p">{`also`}</em>{` show the paths to the specified packages.  For
example, running `}<inlineCode parentName="p">{`npm ls promzard`}</inlineCode>{` in npm's source tree will show:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm@8.0.0 /path/to/npm
└─┬ init-package-json@0.0.4
  └── promzard@0.1.5
`}</code></pre>
    <p>{`It will print out extraneous, missing, and invalid packages.`}</p>
    <p>{`If a project specifies git urls for dependencies these are shown
in parentheses after the `}<inlineCode parentName="p">{`name@version`}</inlineCode>{` to make it easier for users to
recognize potential forks of a project.`}</p>
    <p>{`The tree shown is the logical dependency tree, based on package
dependencies, not the physical layout of your `}<inlineCode parentName="p">{`node_modules`}</inlineCode>{` folder.`}</p>
    <p>{`When run as `}<inlineCode parentName="p">{`ll`}</inlineCode>{` or `}<inlineCode parentName="p">{`la`}</inlineCode>{`, it shows extended information by default.`}</p>
    <h3>{`Note: Design Changes Pending`}</h3>
    <p>{`The `}<inlineCode parentName="p">{`npm ls`}</inlineCode>{` command's output and behavior made a `}<em parentName="p">{`ton`}</em>{` of sense when npm
created a `}<inlineCode parentName="p">{`node_modules`}</inlineCode>{` folder that naively nested every dependency.  In
such a case, the logical dependency graph and physical tree of packages on
disk would be roughly identical.`}</p>
    <p>{`With the advent of automatic install-time deduplication of dependencies in
npm v3, the `}<inlineCode parentName="p">{`ls`}</inlineCode>{` output was modified to display the logical dependency
graph as a tree structure, since this was more useful to most users.
However, without using `}<inlineCode parentName="p">{`npm ls -l`}</inlineCode>{`, it became impossible to show `}<em parentName="p">{`where`}</em>{` a
package was actually installed much of the time!`}</p>
    <p>{`With the advent of automatic installation of `}<inlineCode parentName="p">{`peerDependencies`}</inlineCode>{` in npm v7,
this gets even more curious, as `}<inlineCode parentName="p">{`peerDependencies`}</inlineCode>{` are logically
"underneath" their dependents in the dependency graph, but are always
physically at or above their location on disk.`}</p>
    <p>{`Also, in the years since npm got an `}<inlineCode parentName="p">{`ls`}</inlineCode>{` command (in version 0.0.2!),
dependency graphs have gotten much larger as a general rule.  Therefore, in
order to avoid dumping an excessive amount of content to the terminal, `}<inlineCode parentName="p">{`npm
ls`}</inlineCode>{` now only shows the `}<em parentName="p">{`top`}</em>{` level dependencies, unless `}<inlineCode parentName="p">{`--all`}</inlineCode>{` is
provided.`}</p>
    <p>{`A thorough re-examination of the use cases, intention, behavior, and output
of this command, is currently underway.  Expect significant changes to at
least the default human-readable `}<inlineCode parentName="p">{`npm ls`}</inlineCode>{` output in npm v8.`}</p>
    <h3>{`Configuration`}</h3>
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`all`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`When running `}<inlineCode parentName="p">{`npm outdated`}</inlineCode>{` and `}<inlineCode parentName="p">{`npm ls`}</inlineCode>{`, setting `}<inlineCode parentName="p">{`--all`}</inlineCode>{` will show all
outdated or installed packages, rather than only those directly depended
upon by the current project.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`json`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Whether or not to output JSON data, rather than the normal output.`}</p>
    <ul>
      <li parentName="ul">{`In `}<inlineCode parentName="li">{`npm pkg set`}</inlineCode>{` it enables parsing set values with JSON.parse() before
saving them to your `}<inlineCode parentName="li">{`package.json`}</inlineCode>{`.`}</li>
    </ul>
    <p>{`Not supported by all npm commands.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`long`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Show extended information in `}<inlineCode parentName="p">{`ls`}</inlineCode>{`, `}<inlineCode parentName="p">{`search`}</inlineCode>{`, and `}<inlineCode parentName="p">{`help-search`}</inlineCode>{`.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`parseable`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Output parseable results from commands that write to standard output. For
`}<inlineCode parentName="p">{`npm search`}</inlineCode>{`, this will be tab-separated table format.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`global`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Operates in "global" mode, so that packages are installed into the `}<inlineCode parentName="p">{`prefix`}</inlineCode>{`
folder instead of the current working directory. See
`}<a parentName="p" {...{
        "href": "/cli/v8/configuring-npm/folders"
      }}>{`folders`}</a>{` for more on the differences in behavior.`}</p>
    <ul>
      <li parentName="ul">{`packages are installed into the `}<inlineCode parentName="li">{`{prefix}/lib/node_modules`}</inlineCode>{` folder, instead
of the current working directory.`}</li>
      <li parentName="ul">{`bin files are linked to `}<inlineCode parentName="li">{`{prefix}/bin`}</inlineCode></li>
      <li parentName="ul">{`man pages are linked to `}<inlineCode parentName="li">{`{prefix}/share/man`}</inlineCode></li>
    </ul>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`depth`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: `}<inlineCode parentName="li">{`Infinity`}</inlineCode>{` if `}<inlineCode parentName="li">{`--all`}</inlineCode>{` is set, otherwise `}<inlineCode parentName="li">{`1`}</inlineCode></li>
      <li parentName="ul">{`Type: null or Number`}</li>
    </ul>
    <p>{`The depth to go when recursing packages for `}<inlineCode parentName="p">{`npm ls`}</inlineCode>{`.`}</p>
    <p>{`If not set, `}<inlineCode parentName="p">{`npm ls`}</inlineCode>{` will show only the immediate dependencies of the root
project. If `}<inlineCode parentName="p">{`--all`}</inlineCode>{` is set, then npm will show all dependencies by default.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`omit`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: 'dev' if the `}<inlineCode parentName="li">{`NODE_ENV`}</inlineCode>{` environment variable is set to
'production', otherwise empty.`}</li>
      <li parentName="ul">{`Type: "dev", "optional", or "peer" (can be set multiple times)`}</li>
    </ul>
    <p>{`Dependency types to omit from the installation tree on disk.`}</p>
    <p>{`Note that these dependencies `}<em parentName="p">{`are`}</em>{` still resolved and added to the
`}<inlineCode parentName="p">{`package-lock.json`}</inlineCode>{` or `}<inlineCode parentName="p">{`npm-shrinkwrap.json`}</inlineCode>{` file. They are just not
physically installed on disk.`}</p>
    <p>{`If a package type appears in both the `}<inlineCode parentName="p">{`--include`}</inlineCode>{` and `}<inlineCode parentName="p">{`--omit`}</inlineCode>{` lists, then
it will be included.`}</p>
    <p>{`If the resulting omit list includes `}<inlineCode parentName="p">{`'dev'`}</inlineCode>{`, then the `}<inlineCode parentName="p">{`NODE_ENV`}</inlineCode>{` environment
variable will be set to `}<inlineCode parentName="p">{`'production'`}</inlineCode>{` for all lifecycle scripts.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`link`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Used with `}<inlineCode parentName="p">{`npm ls`}</inlineCode>{`, limiting output to only those packages that are linked.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`package-lock-only`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`If set to true, the current operation will only use the `}<inlineCode parentName="p">{`package-lock.json`}</inlineCode>{`,
ignoring `}<inlineCode parentName="p">{`node_modules`}</inlineCode>{`.`}</p>
    <p>{`For `}<inlineCode parentName="p">{`update`}</inlineCode>{` this means only the `}<inlineCode parentName="p">{`package-lock.json`}</inlineCode>{` will be updated,
instead of checking `}<inlineCode parentName="p">{`node_modules`}</inlineCode>{` and downloading dependencies.`}</p>
    <p>{`For `}<inlineCode parentName="p">{`list`}</inlineCode>{` this means the output will be based on the tree described by the
`}<inlineCode parentName="p">{`package-lock.json`}</inlineCode>{`, rather than the contents of `}<inlineCode parentName="p">{`node_modules`}</inlineCode>{`.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`unicode`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false on windows, true on mac/unix systems with a unicode locale,
as defined by the `}<inlineCode parentName="li">{`LC_ALL`}</inlineCode>{`, `}<inlineCode parentName="li">{`LC_CTYPE`}</inlineCode>{`, or `}<inlineCode parentName="li">{`LANG`}</inlineCode>{` environment variables.`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`When set to true, npm uses unicode characters in the tree output. When
false, it uses ascii characters instead of unicode glyphs.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`workspace`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default:`}</li>
      <li parentName="ul">{`Type: String (can be set multiple times)`}</li>
    </ul>
    <p>{`Enable running a command in the context of the configured workspaces of the
current project while filtering by running only the workspaces defined by
this configuration option.`}</p>
    <p>{`Valid values for the `}<inlineCode parentName="p">{`workspace`}</inlineCode>{` config are either:`}</p>
    <ul>
      <li parentName="ul">{`Workspace names`}</li>
      <li parentName="ul">{`Path to a workspace directory`}</li>
      <li parentName="ul">{`Path to a parent workspace directory (will result in selecting all
workspaces within that folder)`}</li>
    </ul>
    <p>{`When set for the `}<inlineCode parentName="p">{`npm init`}</inlineCode>{` command, this may be set to the folder of a
workspace which does not yet exist, to create the folder and set it up as a
brand new workspace within the project.`}</p>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`workspaces`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: null`}</li>
      <li parentName="ul">{`Type: null or Boolean`}</li>
    </ul>
    <p>{`Set to true to run the command in the context of `}<strong parentName="p">{`all`}</strong>{` configured
workspaces.`}</p>
    <p>{`Explicitly setting this to false will cause commands like `}<inlineCode parentName="p">{`install`}</inlineCode>{` to
ignore workspaces altogether. When not set explicitly:`}</p>
    <ul>
      <li parentName="ul">{`Commands that operate on the `}<inlineCode parentName="li">{`node_modules`}</inlineCode>{` tree (install, update, etc.)
will link workspaces into the `}<inlineCode parentName="li">{`node_modules`}</inlineCode>{` folder. - Commands that do
other things (test, exec, publish, etc.) will operate on the root project,
`}<em parentName="li">{`unless`}</em>{` one or more workspaces are specified in the `}<inlineCode parentName="li">{`workspace`}</inlineCode>{` config.`}</li>
    </ul>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`include-workspace-root`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Include the workspace root when workspaces are enabled for a command.`}</p>
    <p>{`When false, specifying individual workspaces via the `}<inlineCode parentName="p">{`workspace`}</inlineCode>{` config, or
all workspaces via the `}<inlineCode parentName="p">{`workspaces`}</inlineCode>{` flag, will cause npm to operate only on
the specified workspaces, and not on the root project.`}</p>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`install-links`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`When set file: protocol dependencies that exist outside of the project root
will be packed and installed as regular dependencies instead of creating a
symlink. This option has no effect on workspaces.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS END */
    }
    <h3>{`See Also`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/using-npm/package-spec"
        }}>{`package spec`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-explain"
        }}>{`npm explain`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-config"
        }}>{`npm config`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/configuring-npm/npmrc"
        }}>{`npmrc`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/configuring-npm/folders"
        }}>{`npm folders`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-explain"
        }}>{`npm explain`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-install"
        }}>{`npm install`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-link"
        }}>{`npm link`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-prune"
        }}>{`npm prune`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-outdated"
        }}>{`npm outdated`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-update"
        }}>{`npm update`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      